import * as React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import DataTable from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable'
import useFetchPlanningBalances from 'modules/shift_management/components/ShiftManagement/Content/useFetchPlanningBalances'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'

const PrintSchedule = () => {
  const navigate = useNavigate()
  const [{ view }] = useSchedule()
  const [{ shiftsRows }] = useShiftsRows()
  const { balancesByEmployee, periodBalancesByEmployee } = useFetchPlanningBalances()

  useEffect(() => {
    const handleAfterPrint = () => {
      navigate(-1)
    }

    window.addEventListener('afterprint', handleAfterPrint)

    setTimeout(() => {
      window.print()
    }, 100)
    return () => {
      window.removeEventListener('afterprint', handleAfterPrint)
    }
  }, [navigate])

  return (
    <>
      <style>{`
        @media print {
          body, html {
            width: 100vw !important;
            height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
          }
          body * {
            visibility: hidden !important;
          }
          .print-schedule-root, .print-schedule-root * {
            visibility: visible !important;
          }
          .print-schedule-header-absolute {
            position: absolute;
            top: 0;
            left: 0;
            height: 32px;
            display: flex;
            align-items: center;
            padding-left: 8px;
            padding-bottom: 8px;
            font-size: 12px;
            font-weight: 700;
            z-index: 10;
            text-transform: uppercase;
            color: #868e96;
          }
          .print-schedule-print-wrapper {
            display: flex !important;
            justify-content: flex-start !important;
            align-items: flex-start !important;
            width: 100vw !important;
            height: 100vh !important;
            position: fixed !important;
            left: 0; top: 0;
            background: white !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .print-schedule-root {
            transform: scale(0.75);
            transform-origin: top left;
            width: auto !important;
            height: auto !important;
            position: relative !important;
            overflow: visible !important;
            box-sizing: border-box !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .print-schedule-root [style*='translateY(30%)'] { display: none !important; }
          .print-schedule-root span[role="img"][aria-hidden="true"],
          .print-schedule-root span.relative.flex.rounded-full {
            display: none !important;
          }
          .print-schedule-root img {
            display: none !important;
          }
          .print-schedule-root div[role="checkbox"] {
            display: none !important;
          }
          .print-schedule-root button:last-of-type {
            display: none !important;
          }
          @page { margin: 0; size: landscape; }
        }
      `}</style>
      <div className="print-schedule-print-wrapper">
        <div className="print-schedule-root">
          <div className="print-schedule-header-absolute">{view.headerTitle}</div>
          <DataTable
            view={view}
            shiftsRows={shiftsRows}
            showCoverageSection={false}
            contractVersions={contractVersions}
            balancesByEmployee={balancesByEmployee}
            periodBalancesByEmployee={periodBalancesByEmployee}
          />
        </div>
      </div>
    </>
  )
}

export default PrintSchedule
